export default __webpack_public_path__ + "static/media/gainTracker.cefdba6b.svg";